
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TabList, TabPanel, Tabs } from "react-tabs";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import MobileHeader from "../../components/header/MobileHeader";
import registerGraphic from '../../assets/images/khojgraphics/Forgot password page.png'
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import toast from "react-hot-toast";
import axios, { PublicKey } from "../../API/axios";
import useLocalStorage from "use-local-storage";
import { Helmet } from "react-helmet";
import Toggle from "../../Toggle";

function ForgotPassword() {
  const [selectedDropdownOption, setSelectedDropdownOption] = useState(""); // Controls dropdown selection
  const [displays, setDisplays] = useState(false)
  const [isDark, setIsDark] = useLocalStorage("isDark", false);

  const handleDropdownChange = (event) => {
    setSelectedDropdownOption(event.target.value);
  };


  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };



  const [email, setEmail] = useState('')
  const ResetPassword = async (e, responseData) => {
    e.preventDefault()
    try {
      setDisplays(true)
      if (email !== '') {
        const res = await axios.post(`/Auth/ResetPasswordByEmail?EmailAddress=${email}&UserType=${selectedDropdownOption}`, {},
          {
            headers: {
              PublicKey,
            },
          }
        );
        toast.success(res.data.message)
        setEmail('')
        setDisplays(false)
      } else {
        toast.error("please enter required fields!")
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message)
      } else {
        toast.error(error.response.data.message)
      }
    }
  };


  return (
    <>
      <Helmet>
        <title>Forgot-password | Jobkikhoj</title>
        <meta name="description" content=" " />
        <meta name="keywords" content=" " />
        <meta property="og:title" content="Forgot-password | Jobkikhoj " />
        <meta property="og:description" content="" />
        <meta property="og:url" content="https://jobkikhoj.com" />
      </Helmet>
      <header id="header" className="header header-default pt-3">
        <div className="container ct2">
          <div className="row">
            <div className="col-md-12">
              <div className="sticky-area-wrap">
                <div className="header-ct-left">
                  {isDark ? (
                    <div id="logo" className="logo">
                      <Link to="/">
                        <img
                          className="site-logo"
                          id="trans-logo"
                          src={logo2}
                          alt="sitelogo"
                        />
                      </Link>
                    </div>
                  ) : (
                    <div id="logo" className="logo">
                      <Link to="/">
                        <img
                          className="site-logo"
                          id="trans-logo"
                          src={logo}
                          alt="sitelogo"
                        />
                      </Link>

                    </div>

                  )}
                </div>
                <div className="header-ct-center">
                  <div className="nav-wrap"></div>
                </div>
                <div className="header-ct-right">
                  <Toggle
                    isChecked={isDark}
                    handleChange={() => setIsDark(!isDark)}
                    className="desktopToggle"
                  />
                  <Link to="/Login" className="">
                    <div className="khojPrimaryBtn ms-3">
                      Login
                    </div>
                  </Link>
                  <div className="form-group-4 ms-3">
                    <Link to="/Register" className="">
                      <div className="khojSecondaryBtn">
                        Register
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="pt-70">
        <div className="container">
          <div className="row d-flex align-items-center pt-4">
            <div className="col-md-6 registerGraphics">
              <img src={registerGraphic} width={'100%'} />
            </div>
            <div className="col-md-6 ">
              <Tabs className="wd-form-login tf-tab">
                <h4 className="mt-3">Forgot Password</h4>
                <div className="content-tab">
                  <TabPanel className="inner animation-tab">
                    <form action="/">
                      <div className="ip">

                        <p>Forgot your password? Enter your email and we will send a link to help you reset it.</p>
                      </div>

                      {/* <TabList className="menu-tab">
                        <li className={`me-4 ${selectedDropdownOption ? "bg-card-visible" : ""}`}>
                          {selectedDropdownOption}
                        </li>
                        <div className="post-form-group">
                          <select
                            className="ct-tab-dropdown"
                            value={selectedDropdownOption}
                            onChange={handleDropdownChange}
                          >
                            <option value="">Select UserType</option>
                            <option value="Candidate">Candidate</option>
                            <option value="Institution">Institution</option>
                            <option value="Company">Company</option>
                            <option value="Recruiter">Recruiter</option>
                          </select>
                        </div>
                      </TabList> */}
                      <div className="ip mt-4">
                        <label>Email ID</label>
                        <input
                          type="email"
                          // defaultValue="Tony Nguyen"
                          placeholder="Email"
                          onChange={(e) => { setEmail(e.target.value) }}
                          value={email}
                          id="email"
                          name="email"
                          invalid={displays && email === ''}
                        />
                        {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                      </div>

                      <button type="submit" onClick={(e) => ResetPassword(e)}>
                        Send

                      </button>
                    </form>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
